module.exports = {
  footerText: 'PT. BPRS Lantabur Tebuireng 22',
}
